import styles from './SpeakerEqualizer.module.css';

interface SpeakerEqualizerProps {
  isActive: boolean;
  size?: 'default' | 'status';
}

export function SpeakerEqualizer(props: SpeakerEqualizerProps) {
  return (
    <span
      aria-hidden="true"
      className={styles.root}
      data-is-active={props.isActive}
      data-size={props.size ?? 'default'}
    >
      <span className={styles.bar} />
      <span className={styles.bar} />
      <span className={styles.bar} />
      <span className={styles.bar} />
      <span className={styles.bar} />
    </span>
  );
}
